{
  "billing": {
    "title": "Billing",
    "page_title": "Billing and plans",
    "page_content": "You can change and manage your subscription plan and edit your payment details.",
    "in_arrears_error": {
      "title": "Missing or invalid payment method",
      "content": "Your account is currently suspended. Please update your payment details to activate your account"
    },
    "cancelled_error_payed": {
      "title": "Current subscription is cancelled",
      "content_1": "Your account has been cancelled. Please",
      "content_2": "contact us",
      "content_3": "to reactivate your account"
    },
    "cancelled_error_trial": {
      "title": "Your trial period is over",
      "content": "Your account has been cancelled. Please change your plan to a payed plan to continue using Iventis."
    },
    "subscription_box": {
      "title": "Subscription",
      "current_plan": "Current plan",
      "next_payment": "Next payment",
      "renews_on": "Renews on",
      "paid": "Paid",
      "days": "to go",
      "get_in_touch": "Get in touch to discuss your plan",
      "Trial": "Trial",
      "Active": "Active",
      "Cancelled": "Cancelled",
      "InArrears": "In arrears"
    },
    "change_plan": "Change plan",
    "payment_details_box": {
      "title": "Payment Details",
      "payment_method": "Payment method",
      "card_ending": "Card ending in",
      "expires": "Expires",
      "billing_address": "Billing address",
      "no_payment_method": "No payment method",
      "payment_breakdown_project": "{{ amount }} (1 project x {{ amount }})",
      "payment_breakdown_users": "{{ totalAmount }} ({{ maxUsers }} users x {{ userAmount }})",
      "payment_breakdown_user": "{{ totalAmount }} (1 user x {{ totalAmount }})",
      "users": "users",
      "user": "user",
      "discount": "discount"
    },
    "redirect_modal": {
      "title": "Edit Payment Method",
      "content": "You will be redirected to our billing provider to edit your payment details."
    },
    "excludes_taxes": "Excludes any applicable taxes"
  },
  "upgrade_plan_warnings": {
    "upgrade_plan": "Upgrade plan",
    "contact_us": "Contact us",
    "view_plans": "View plans"
  },
  "view_plans": "View plans",
  "subscription_details": {
    "title": "Subscription details",
    "selected_plan": "Selected plan",
    "plan_type": "Plan type",
    "currency": "Currency",
    "billed": "Billed",
    "payment_date": "Payment date",
    "payment_date_desc": {
      "Monthly": "{{ date }} of every month",
      "Annually": "{{ date }}"
    },
    "renewal_date": "Renewal date",
    "add_users": "Add users",
    "add_payment_method": "Add payment method",
    "cannot_switch_from_annual": "Please contact us if you need to switch from annual to monthly billing",
    "exceeded_max_users_message": "Please contact us to discuss your requirements if you need more than {{ numberOfUsers }} users",
    "continue_to_payment": "Continue to payment",
    "redirect_modal": {
      "title": "Edit subscription",
      "message": "By clicking continue, you will be redirected to our billing provider to make any required payments towards the updated subscription"
    },
    "update_successful": "Subscription successfully updated"
  },
  "subscription_price_breakdown": {
    "title": "Price breakdown",
    "subscription_fee": "Subscription fee",
    "individual_price_breakdown": "Individual price breakdown",
    "discount_applied": "Discount applied",
    "discount_has_been_applied": "A {{ discount }} discount has been auto-applied to your account",
    "total": "Total",
    "frequency_proice_breakdown": "{{ frequency }} price breakdown",
    "frequency": {
      "Monthly": "Monthly",
      "Annually": "Annually"
    },
    "time_unit": {
      "Monthly": "months",
      "Annually": "year"
    },
    "users": "users",
    "excludes_taxes": "Excludes any applicable taxes which will be added on the payment page"
  },
  "subscription_payment_breakdown": {
    "title": "Payment breakdown",
    "vat": "VAT ({{ percentage }} on {{ total }})",
    "total_excluding_tax": "Total excluding tax",
    "amount_due": "Amount due",
    "description": "Description",
    "total": "Total",
    "unit": "Unit",
    "pay": "Pay {{ amount }}"
  },
  "order_summary": "Order summary",
  "settings": "Settings"
}